import { useCallback } from "react";
import confetti from "canvas-confetti";

export function usePayoutCelebration() {
  const celebrate = useCallback((origin?: { x: number; y: number }) => {
    confetti({
      particleCount: 60,
      spread: 55,
      angle: 90,
      origin: origin ?? { x: 0.5, y: 0.5 },
      startVelocity: 35,
      decay: 0.92,
      scalar: 0.9,
      colors: ["#00C9A7", "#F5C842", "#3D6EFF", "#ffffff"],
      disableForReducedMotion: true,
    });
  }, []);

  return { celebrate };
}
